import { BlurSize } from "./GaussianBlurRenderPass";

export const BLUR_SIZES = {
    // No filtering: the target is used as it is, see SsaoRenderPass.renderSsao.
    "NONE": undefined,
    "KERNEL_2": BlurSize.KERNEL_2,
    "KERNEL_3": BlurSize.KERNEL_3,
    "KERNEL_4": BlurSize.KERNEL_4,
    "KERNEL_5": BlurSize.KERNEL_5
}
